import { time, Scheduler, bridge, store, coreEngine } from "@dinahmoe/dmafjs-core";
import { WebAudioSound } from "./sound.js";

class WebAudioSoundGeneric extends WebAudioSound {
  namespace = "webaudio:sound:generic";

  init(node) {
    //a sound cannot be started on the same event as the audio context is unlocked
    //the webaudio commtext time offset is not set yet which will cause a delay

    super.init(node);
    node.pendingPlay = new Scheduler(this, this.doPlay);
    node.pendingStop = new Scheduler(this, this.doStop);
    node.pendingClearRetrig = new Scheduler(this, this.doClearRetrig);
    node.playing = false;
    node.lastPlayTime;
  }

  execute(node, config, event) {
    this.play(node, config, event);
  }

  play(node, config, event) {
    node.pendingStop.clear();
    node.pendingPlay.clear();

    const playAtTime = node.props.ignoreEventTime ? time.current : event.time;

    // TODO can still be retrigged with multiple clicks during fadeOut
    if (node.props.reTrig > 0) {
      if (node.playing && node.lastPlayTime + node.props.reTrig > time.current) {
        //ignore
        return;
      }
    }

    node.lastPlayTime = time.current;
    node.playing = true;
    node.pendingPlay.schedule(playAtTime, node, playAtTime);
  }

  doPlay(node, eventTime) {
    if (!store.get(`assets.buffer.${node.props.assetId}`)) {
      console.error(`audio file ${node.props.assetId} was not loaded, ignoring play`);
      return;
    }

    bridge.update({
      uid: "webaudio/" + node.uid,
      key: "play",
      value: {
        time: eventTime,
        assetId: node.props.assetId,
        playbackRate: node.props.playbackRate,
        fadeIn: node.props.fadeIn,
      },
      sender: "core",
    });
  }

  stop(node, config, event) {
    node.pendingPlay.clear();
    node.pendingStop.clear();

    node.pendingStop.schedule(event.time, node, event.time, config.fadeOut);
  }

  doStop(node, eventTime, fadeOut) {
    bridge.update({
      uid: "webaudio/" + node.uid,
      key: "stop",
      value: {
        time: eventTime,
        assetId: node.props.assetId,
        fadeOut,
      },
      sender: "core",
    });
    node.pendingClearRetrig.schedule(eventTime + fadeOut, node);
  }
  
  doClearRetrig(node) {
    node.playing = false;
  }
}

const webAudioSoundGeneric = new WebAudioSoundGeneric();
export { webAudioSoundGeneric, WebAudioSoundGeneric };
